import moment from "moment";
import React from "react";
import { CircularAvatar } from "..";
import "./Comments.scss";
import { useLocation } from "react-router-dom";
import { DropDownType } from "../../../commonTypes/clientDirectoryTypes";
type AppProps = {
  commenterName?: string | null;
  commentTime?: string;
  commentText: string;
  image?: any;
  type?: any;
  clientName?:DropDownType
  typeJobClosure?:string;
};

const Comments = ({
  commenterName,
  commentText,
  commentTime,
  clientName,
    image,
  type,
  typeJobClosure
}: AppProps) => {
  const { pathname } = useLocation();

  return (
    <div className="mb-2 mt-2">
      <div className= {typeJobClosure==="jobClosure"? "d-flex align-items-center":"d-flex justify-content-between align-items-center"}   style={typeJobClosure === "jobClosure" ? { gap: '10px' } : {}}>
        <div className="d-flex flex-row align-items-center">
          <CircularAvatar
            name={commenterName ? commenterName : "Anonymous"}
            image={image?.file_url}
          />
          <div></div>
          <p className="mb-0 ml-1 commenter-text">
            {commenterName && commenterName.length > 1
              ? commenterName
              : "Anonymous"}
          </p>
        </div>
        <div className="d-flex align-items-center">
          {pathname?.includes("invoice-generation") ? (
            <p className="due-date-text mb-0">
              {moment.utc(commentTime).local().format("DD-MM-YYYY, h:mm a")}
            </p>
          ) : (
            <p className="due-date-text mb-0">
              {moment(commentTime).local().format("DD-MM-YYYY, h:mm a")}
            </p>
          )}
        </div>
      </div>
      <p className="comment-text">
        {type?.length ? (
          <a style={{ cursor: "pointer" }} href={`${commentText}?client_code=${clientName?.value}&company_name=${clientName?.label?.split(")")[1]?.trim()}`} target="_blank">
            {commentText}
          </a>
        ) : (
          commentText
        )}
      </p>
    </div>
  );
};

export default Comments;
